export const TEST_NODE_TYPES = {
  startTest: 'startTest',
  inProgress: 'inProgress',
  completed: 'completed',
  error: 'error',
};
